export default class Actor {
  none;

  constructor() {
    this.nonce = Math.random().toString(36).substring(7);
  }
}
